export { default as Home } from "./Home";
export { default as Lake } from "./Lake";
export { default as Register } from "./Register";
export { default as Search } from "./Search";
export { default as Tips } from "./Tips";
export { default as Entries } from "./Entries";